export default {
  authUser: {},
}
